import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
}

export const AssessmentReportIcon: React.FunctionComponent<IProps> = props => {
	const { className, fillColor } = props;
	return (
		<SvgIcon className={`${className || ''}`} height={16} width={20}>
			<g width='16' height='16' fill='none'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.21053 12.6316C4.21053 12.1659 3.83326 11.7895 3.36842 11.7895H0.842105C0.377263 11.7895 0 12.1659 0 12.6316V14.3158C0 14.7815 0.377263 15.1579 0.842105 15.1579H3.36842C3.83326 15.1579 4.21053 14.7815 4.21053 14.3158V12.6316Z'
					fill={fillColor || '#00AAE8'}
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.1053 6.73682C10.1053 6.27114 9.72804 5.89471 9.2632 5.89471H6.73688C6.27204 5.89471 5.89478 6.27114 5.89478 6.73682V14.3158C5.89478 14.7815 6.27204 15.1579 6.73688 15.1579H9.2632C9.72804 15.1579 10.1053 14.7815 10.1053 14.3158V6.73682Z'
					fill={fillColor || '#00AAE8'}
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M16 0.842105C16 0.376421 15.6227 0 15.1578 0H12.6315C12.1667 0 11.7894 0.376421 11.7894 0.842105V14.3158C11.7894 14.7815 12.1667 15.1579 12.6315 15.1579H15.1578C15.6227 15.1579 16 14.7815 16 14.3158V0.842105Z'
					fill={fillColor || '#00AAE8'}
				/>
			</g>
		</SvgIcon>
	);
};
